export default function validateBrandName(brandName: string) {
    if (brandName !== 'WINCK' && brandName !== 'HEYLOHA') {
        throw Error('Invalid app brand provided');
    }
}
